import { mapState, mapGetters, mapActions } from 'vuex'

import BaseModal from '../BaseModal'

import MainButton from '../atoms/MainButton'

export default {
	name		: 'ModalProgress',
	components	: {
		BaseModal,
		MainButton
	},
	props		: {
		isVisible: Boolean
	},
	watch: {
		isVisible(visible) {
			if (visible && (!this.expectationLabels || !Object.keys(this.expectationLabels).length)) {
				this.loadExpectationLabels()
			}
		},
	},
	methods: {
		...mapActions('pointAB', {
			fetchExpectationOptions: 'GET_EXPECTATION_OPTIONS',
		}),
		loadExpectationLabels() {
			const lang = this.$store.getters.currentLanguage
				? this.$store.getters.currentLanguage.translationKey
				: (this.$route.params.lang || 'uk')

			this.fetchExpectationOptions({ lang }).catch(() => {})
		},
	},
	computed	: {
		...mapState('pointAB', {
			progressAnalysis	: state => state.analysis,
			isAnalysisLoading	: state => state.isLoadingAnalysis,
		}),
		...mapGetters('pointAB', ['pointAData', 'pointBData', 'progressComparison', 'expectationLabels']),
		skillGrowth() {
			return this.progressComparison ? this.progressComparison.skillGrowth : 0
		},
		formattedExpectations() {
			const labels = this.expectationLabels || {}

			return this.pointAData.expectations.map(exp => {
				if (exp === 'other') {
					return this.pointAData.expectationOther || labels.other || 'Свій варіант'
				}

				return labels[exp] || exp
			})
		},
		goalsAchievedText() {
			const texts = {
				yes: '✅ Так, повністю',
				partially: '⚠️ Частково',
				no: '❌ Ні'
			}
			
			return texts[this.pointBData.goalsAchieved] || 'Не вказано'
		},
		/** Текст для блоку AI (не показувати сирий об’єкт зі store) */
		aiSummaryText() {
			const a = this.progressAnalysis
			if (!a) return ''
			const s = a.summary != null ? String(a.summary).trim() : ''
			if (s) return s
			const c = a.skillGrowthComment != null ? String(a.skillGrowthComment).trim() : ''
			if (c) return c
			return ''
		}
	}
}
